<script setup lang="ts" generic="T extends Record<string, any>">
defineProps<{
  item: T;
  dataKey: keyof T;
  dataValue: keyof T;
  subOptionsKey: string;
  subOptionKey?: string;
  subOptionValue?: string;
}>();

const emit = defineEmits<{
  select: [item: any, parent?: T]; // ← must accept a second arg
}>();

function hasSubOptions(item: T, subOptionsKey: string): boolean {
  return Array.isArray(item[subOptionsKey]) && item[subOptionsKey].length > 0;
}
</script>

<template>
  <li>
    <div
      v-if="hasSubOptions(item, subOptionsKey)"
      class="px-4 py-2 font-bold cursor-default select-none"
    >
      {{ item[dataValue] }}
    </div>
    <div
      v-else
      @mousedown="emit('select', item)"
      class="px-4 py-2 cursor-pointer hover:bg-primary hover:text-white"
    >
      {{ item[dataValue] }}
    </div>

    <ul v-if="hasSubOptions(item, subOptionsKey)" class="pl-3 border-l ml-4">
      <li
        v-for="subItem in item[subOptionsKey]"
        :key="subOptionKey ? subItem[subOptionKey] : JSON.stringify(subItem)"
        @mousedown="emit('select', subItem, item)"
        class="px-4 py-2 cursor-pointer hover:bg-primary hover:text-white"
      >
        {{ subOptionValue ? subItem[subOptionValue] : subItem[dataValue] }}
      </li>
    </ul>
  </li>
</template>
